import { VendedorSelectService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/services/api/vendedor-service/vendedor-service.service';
import { Inject, Injectable, Injector } from '@angular/core';
import {
  FormasDeEntrega,
  TransportadoraResponse,
} from '../../../models/transportadora.models';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';

@Injectable({
  providedIn: 'root',
})
export class NewApiTransportadoraService extends UtilsBaseApiService<NewApiTransportadoraService> {
  readonly ENTREGA_FORMAS_DE_ENTREGA_CONTEXT = 'entrega/formas_de_entrega';
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private readonly vendedorSelectService: VendedorSelectService
  ) {
    super('transportadora', injector, environment.BASE_API_URL);
  }

  getTransportadora() {
    return this.httpClient.get<TransportadoraResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}`
    );
  }

  getMetodoDeEntrega() {
    return this.httpClient.get<FormasDeEntrega[]>(
      `${this.BASE_URL}${this.ENTREGA_FORMAS_DE_ENTREGA_CONTEXT}?idvend=${this.vendedorSelectService.vendedorActiv()}`
    );
  }
}
